<template>
  <div>
    <!--搜索栏-->
    <searchBar
      :search-form="searchForm"
      name
      status
      mobile
      btn-add
      @handleAdd="handleAdd"
      @handleSearch="getData"
    ></searchBar>

    <!--表格-->
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
      ></el-table-column>

      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        :prop="index"
        align="center"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="140">
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" type="text" size="mini">
            编辑
          </el-button>
          <el-button
            @click="handleEnabled(scope.row)"
            type="text"
            :style="{ color: scope.row.status === 1 ? 'red' : '' }"
            size="mini"
          >
            {{ scope.row.status === 1 ? "禁用" : "启用" }}
          </el-button>
          <el-button
            @click="handleDelete(scope.row)"
            type="text"
            style="color:red"
            size="mini"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout=" prev, pager, next, jumper, sizes"
        :total="totalElements"
      ></el-pagination>
    </div>

    <!--新增Dialog-->
    <el-dialog
      title="添加代表"
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        label-suffix="："
        label-position="right"
        :status-icon="true"
      >
        <el-form-item label="姓名" label-width="100px" prop="name">
          <el-input
            v-model="form.name"
            size="medium"
            placeholder="姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" label-width="100px" prop="mobile">
          <el-input
            v-model="form.mobile"
            size="medium"
            type="num"
            maxlength="11"
            placeholder="手机号"
          ></el-input>
        </el-form-item>

        <el-form-item label="职务" label-width="100px" prop="occupation">
          <el-input
            v-model="form.occupation"
            size="medium"
            placeholder="职务"
          ></el-input>
        </el-form-item>

        <el-form-item label="职责" label-width="100px" prop="responsibility">
          <el-input
            v-model="form.responsibility"
            autosize
            type="textarea"
            size="medium"
            placeholder="职责"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { downloadFile } from "@/assets/http/utils"
import Axios from "axios"
import apiUrl from "@/assets/http/apiUrl"
import { resetObject } from "@/utils"
import { pick } from "lodash"

const formProps = ["uid", "name", "mobile", "occupation", "responsibility"]

export default {
  name: "PartyMamber",
  data() {
    let Self = this

    // 表单验证
    let validateMobile = (rule, value, callback) => {
      if (/^1[3456789]\d{9}$/.test(value)) {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("手机号验证失败"))
      }
    }
    let validateIdCard = (rule, value, callback) => {
      if (
        /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          value
        )
      ) {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("身份证号验证失败"))
      }
    }

    return {
      // 页面初始数据
      totalElements: 10,
      totalPages: 1,
      size: 10,
      page: 1,

      serverUrl: apiUrl.ServerUrl,

      // 搜索栏初始化
      searchForm: {
        partyOrg: "",
        status: "",
        name: "",
      },

      // 表头初始化
      tableHeader: {
        name: "名称",
        mobile: "手机号",
        occupation: "职务",
        responsibility: "职责",
        statusName: "状态",
      },

      // 表格数据
      tableData: [],

      // dialog可见性
      dialogFormVisible: false,
      dialogUploadVisible: false,

      // 上传文件列表
      file: "",

      // 新增表单
      form: {
        uid: "",
        name: "",
        mobile: "",
        occupation: "",
        responsibility: "",
      },

      // 表单验证规则
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],

        mobile: [
          {
            required: true,
            validator: validateMobile,
            trigger: "blur",
          },
        ],
        occupation: [
          {
            required: true,
            message: "请输入职务",
            trigger: "blur",
          },
        ],
        responsibility: [
          {
            required: true,
            message: "请选择职责",
            trigger: "blur",
          },
        ],
        family: [
          {
            required: true,
            message: "请选择所属家庭",
            trigger: "blur",
          },
        ],
        occupation: [
          {
            required: true,
            message: "请选择工作类型",
            trigger: "blur",
          },
        ],
      },

      partyOrgOptions: [],
    }
  },
  async created() {
    this.getPartyOrgOptions()
    this.getData()
  },
  methods: {
    getImgPreviewList(url) {
      let arr = new Array(this.serverUrl + url)
      return arr
    },

    /*请求数据
     * */
    getData() {
      this.request({
        url: "/manager/party/findPartyMember",
        method: "get",
        params: {
          page: this.page,
          size: this.size,

          ...this.searchForm,
        },
      })
        .then(res => {
          this.size = res.data.data.size
          this.page = res.data.data.page
          this.totalElements = Number(res.data.data.totalElements)
          this.totalPages = res.data.data.totalPages

          this.tableData = res.data.data.content
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    getPartyOrgOptions() {
      this.request({
        url: "/manager/party/getPartyList",
        method: "get",
        params: {},
      })
        .then(res => {
          this.partyOrgOptions = res.data.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*更改单页数据数量*/
    handleSizeChange(size) {
      this.size = size
      this.getData()
    },

    /*页码跳转
     * */
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },

    /*启用/禁用
     * */
    handleEnabled(rowData) {
      let status = rowData.status === 1 ? 2 : 1
      this.request({
        url: "/manager/party/updateMemberStatus",
        data: {
          uid: rowData.uid,
          status: status,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*编辑*/
    handleEdit(rowData) {
      this.form = { ...rowData }
      this.dialogFormVisible = true
    },

    handleAdd() {
      this.dialogFormVisible = true
    },

    /*删除*/
    handleDelete(rowData) {
      this.$confirm("确认删除?")
        .then(() => {
          this.request({
            url: "/manager/party/deletePartyMember",
            params: {
              uid: rowData.uid,
            },
            method: "DELETE",
          })
            .then(res => {
              this.$message.success("删除成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },

    /*dialog提交*/
    dialogConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.dialogFormVisible = false

          this.request({
            url: "/manager/party/addOrUpdatePartyMember",
            data: {
              ...this.form,
            },
            method: "post",
          })
            .then(res => {
              if (res.data.status === "BAD_REQUEST") {
                this.$message.warning(res.data.message)
              }

              this.getData()
              resetObject(this.form)
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        }
      })
    },

    /*dialog取消*/
    dialogCancel() {
      this.dialogFormVisible = false
      /*关闭时将添加会options中的'全部'*/
      resetObject(this.form)
    },
  },
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
